import { customInstance } from 'lib/api-instance'

export type ReaderListSummary = {
  id: number
  name: string
  description: string | null
  itemsCount: number
  createdAt: string
}

type ResponseSuccess<T> = {
  data: T
  status: number
  headers: Headers
}

export const getReaderLists = async (
  options?: RequestInit
): Promise<ResponseSuccess<{ data: ReaderListSummary[] }>> => {
  return customInstance<ResponseSuccess<{ data: ReaderListSummary[] }>>(
    '/api-arvore/reader-lists',
    {
      ...options,
      method: 'GET'
    }
  )
}

export const getListsContainingBook = async (
  slug: string,
  options?: RequestInit
): Promise<ResponseSuccess<{ listIds: number[] }>> => {
  return customInstance<ResponseSuccess<{ listIds: number[] }>>(
    `/api-arvore/reader-lists/containing/${slug}`,
    {
      ...options,
      method: 'GET'
    }
  )
}

export const createReaderList = async (
  name: string,
  options?: RequestInit
): Promise<ResponseSuccess<{ id: number }>> => {
  return customInstance<ResponseSuccess<{ id: number }>>(
    '/api-arvore/reader-lists',
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify({ name })
    }
  )
}

export const addBookToReaderList = async (
  listId: number,
  slug: string,
  options?: RequestInit
): Promise<ResponseSuccess<void>> => {
  return customInstance<ResponseSuccess<void>>(
    `/api-arvore/reader-lists/${listId}/items`,
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify({ slug })
    }
  )
}

export const removeBookFromReaderList = async (
  listId: number,
  slug: string,
  options?: RequestInit
): Promise<ResponseSuccess<void>> => {
  return customInstance<ResponseSuccess<void>>(
    `/api-arvore/reader-lists/${listId}/items/${slug}`,
    {
      ...options,
      method: 'DELETE'
    }
  )
}
